module.exports = __webpack_public_path__ + "static/media/fond_logo.8b42dfb0.jpg";